<div class="form-step-field__options-editor" [formGroup]="fieldGroup">
	<div class="form-step-field__options-list" formArrayName="options">
		@for (opt of optionsArray.controls; track opt; let oi = $index) {
			<div class="form-step-field__option-row" [formGroupName]="oi">
				<div class="form-step-field__option-input" [id]="'form-step-option-' + oi">
					<tec-form-group [errorMsg]="optionLabelErrorMessage(oi)">
						<tec-input
							[formControl]="getOptionLabelControl(oi)"
							[placeholder]="'WORKFLOWS.FORM.OPERATIONS.MODAL_FORM_STEP.OPTION_PLACEHOLDER' | translate"
							[hasError]="optionLabelHasError(oi)"
						></tec-input>
					</tec-form-group>
				</div>

				<tec-button-icon
					[icon]="'icon-trash'"
					[type]="'default'"
					(clickEvent)="removeOption(oi)"
				></tec-button-icon>
			</div>
		}
	</div>

	<tec-link [label]="'BUTTON.ADD' | translate" (click)="addOption()" />
</div>
